import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";
import LoadingIndicator from "../../simple/LoadingIndicator/LoadingIndicator";

// import geoJson from "../../../geojson.json";

import "./styles.temp.scss";

const containerStyle = {
  width: "100%",
  height: "100%"
};

const AudienceMap = React.memo(
  ({ mapLayout, isMapLayoutLoading, mapCenter, mapZoom }) => {
    const { isLoaded } = useJsApiLoader({
      id: "google-map-script",
      googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY
    });

    const [map, setMap] = useState(null);
    const [isMapExists, setIsMapExists] = useState(false);

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(() => {
      if (mapLayout && isMapExists) {
        map.data.forEach(feature => {
          map.data.remove(feature);
        });

        // if pass empty object we'll have an error
        if (Object.keys(mapLayout).length > 0) {
          map.data.addGeoJson(mapLayout);
        }

        if (mapLayout.features?.length === 0) {
          console.log("No features, set center: ", mapCenter);
          map.setCenter(mapCenter);
        } else {
          const bounds = new window.google.maps.LatLngBounds();
          map.data.forEach(feature => {
            feature.getGeometry().forEachLatLng(latlng => {
              bounds.extend(latlng);
            });
          });
          map.fitBounds(bounds);
        }
      }
    }, [mapLayout, isMapExists]);
    /* eslint-enable react-hooks/exhaustive-deps */

    // eslint-disable-next-line no-shadow
    const onLoad = React.useCallback(function callback(map) {
      map.data.setStyle(() => {
        return {
          fillColor: "#548235",
          strokeColor: "#548235",
          fillOpacity: 0.9,
          strokeOpacity: 0.9,
          strokeWeight: 0.5
        };
      });
      setMap(map);
      setIsMapExists(true);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // eslint-disable-next-line no-shadow, no-unused-vars
    const onUnmount = React.useCallback(function callback(map) {
      setMap(null);
    }, []);

    return (
      <div style={{ width: "100%" }}>
        {isLoaded && !isMapLayoutLoading ? (
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={mapCenter}
            zoom={mapZoom}
            onLoad={onLoad}
            onUnmount={onUnmount}
            // onCenterChanged={() => {
            //   if (mapLayout.features?.length === 0 && map) {
            //     const { lat, lng } = mapCenter;
            //     console.log(map.center.lat(), map.center.lng())
            //     if (lat !== map.center.lat() && lng !== map.center.lng()) {
            //       map.setCenter(mapCenter);
            //     }
            //   }
            // }}
          >
            {/* Child components, such as markers, info windows, etc. */}
          </GoogleMap>
        ) : (
          <>
            <LoadingIndicator />
          </>
        )}
      </div>
    );
  }
);

AudienceMap.propTypes = {
  mapLayout: PropTypes.shape({
    type: PropTypes.string,
    features: PropTypes.arrayOf(PropTypes.shape({}))
  }),
  isMapLayoutLoading: PropTypes.bool,
  mapCenter: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number
  }),
  mapZoom: PropTypes.number
};

AudienceMap.defaultProps = {
  mapLayout: null,
  isMapLayoutLoading: false,
  mapCenter: {
    lat: -3.745,
    lng: -38.523
  },
  mapZoom: 1
};

export default AudienceMap;
